import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { getInitiative as getInitiativeGql } from 'src/graphql/queries/getInitiative.gql'
import useMyNotificationCount from './useMyNotificationCount'

const useInitiative = (variables, options = {}) => {
   const { refetch: refetchNotificationCount } = useMyNotificationCount()
   const { data, error, networkStatus, refetch, loading } = useQuery(getInitiativeGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
      ...options
   })

   useEffect(() => {
      if (!loading) {
         refetchNotificationCount()
      }
   }, [loading])

   const hasFatalErrors = error?.networkError ||
      error?.graphQLErrors?.some(err => err?.extensions?.exception?.name !== 'NonFatal')

   if (hasFatalErrors) {
      throw error
   }

   return {
      initiative: data ? data.initiative : undefined,
      error,
      loading,
      networkStatus,
      refetch
   }
}

export default useInitiative
